





































import {Component, Vue} from 'vue-property-decorator';
import {mapMutations} from 'vuex';
import {cloneDeep, isEqual} from 'lodash';
import Main from './tabs/Main.vue';
import Import from './tabs/Import.vue';
import Extra from './tabs/Extra.vue';
import MarginCalculation from './tabs/marginCalculation/MarginCalculation.vue';
import HidingVeneerAndPlywoodProperties from './tabs/HidingVeneerAndPlywoodProperties.vue';
import CConfirmDialog from '@/components/base/dialog/CConfirmDialog.vue';

Component.registerHooks(['beforeRouteLeave']);
@Component({
    components: {CConfirmDialog},
    methods: {
        ...mapMutations(['setHideableProperties']),
    },
})
export default class Settings extends Vue {
    private loading: boolean = false;
    private data: any = null;
    private initialData: any = null;
    private tab: number = 0;
    public setHideableProperties!: Function;

    get tabConfig() {
        return [
            {
                name: this.$t('Common.Main'),
                component: Main,
            },
            {
                name: this.$t('Common.Import'),
                component: Import,
            },
            {
                name: this.$t('Common.Extra'),
                component: Extra,
            },
            {
                name: this.$t('Common.MarginalityCalculation'),
                component: MarginCalculation,
            },
            {
                name: this.$t('Systems.Company.HidingVeneerAndPlywoodProperties'),
                component: HidingVeneerAndPlywoodProperties,
            },
        ];
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    get hasUnsavedChanges() {
        return !isEqual(this.data, this.initialData);
    }

    created() {
        this.getData();
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        if (this.hasUnsavedChanges)
            (this.$refs.confirm as any).open(
                {
                    text: 'У вас есть несохраненные изменения, вы уверены, что хотите перейти?',
                },
                {
                    callback: () => {
                        next();
                    },
                },
            );
        else next();
    }

    async getData() {
        const timerId = setTimeout(() => (this.loading = true), 100);
        try {
            const {data} = await this.$http.get(`${this.$api.settings}/GetEdit`);
            this.data = data;
            this.initialData = cloneDeep(data);
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    reset() {
        if (!this.hasUnsavedChanges) return;
        this.data = cloneDeep(this.initialData);
    }

    async save() {
        if (!this.hasUnsavedChanges) return;
        let correct = true;
        const items = this.$refs.content as any;
        for (let i = 0; i < items.length; i++) {
            const validation = items[i].validate();
            if (!validation.valid) {
                this.tab = validation.tab;
                correct = false;
                break;
            }
        }
        if (!correct) return;
        const timerId = setTimeout(() => (this.loading = true), 100);
        try {
            const {data} = await this.$http.post(`${this.$api.settings}/Save`, this.data);
            this.data = data;
            this.initialData = cloneDeep(data);
            this.setHideableProperties(data.HideableProperties);
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
}
